import { createPortal } from "react-dom";
import { Phone, PhoneOff, X } from "lucide-react";

function IncomingCallModal({
  open,
  callerLabel,
  onAccept,
  onDecline,
  onIgnore,
  // Backwards-compatible fallbacks.
  onJoin,
  onDismiss,
}) {
  if (!open) return null;

  const handleAccept = onAccept || onJoin;
  const handleDecline = onDecline || onDismiss;
  const handleIgnore = onIgnore || onDismiss;

  // Render directly into document.body so the modal is never clipped by any
  // parent container in the workspace (overflow:hidden, CSS transforms, etc.).
  return createPortal(
    <div className="fixed inset-0 z-call flex items-center justify-center bg-slate-900/40 px-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow-xl p-6">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0">
            <p className="text-xs uppercase tracking-wide text-emerald-700 font-semibold">
              Incoming Resolution Call
            </p>
            <h3 className="mt-1 text-lg sm:text-xl font-bold text-slate-900">
              {callerLabel} is calling...
            </h3>
            <p className="mt-1 text-sm text-slate-500 flex items-center gap-1.5">
              <span className="inline-block w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
              Ringing
            </p>
          </div>
          <button
            onClick={handleIgnore}
            className="inline-flex items-center justify-center w-8 h-8 rounded-full text-slate-500 hover:bg-slate-100 hover:text-slate-700"
            aria-label="Ignore incoming call"
          >
            <X className="w-4 h-4" />
          </button>
        </div>

        <div className="mt-6 flex gap-3">
          <button
            onClick={handleAccept}
            className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-emerald-600 text-white hover:bg-emerald-700 active:bg-emerald-800 transition font-semibold text-sm"
          >
            <Phone className="w-4 h-4 text-white" />
            Accept
          </button>
          <button
            onClick={handleDecline}
            className="flex-1 inline-flex items-center justify-center gap-2 px-4 py-3 rounded-xl bg-rose-600 text-white hover:bg-rose-700 active:bg-rose-800 transition font-semibold text-sm"
          >
            <PhoneOff className="w-4 h-4 text-white" />
            Decline
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default IncomingCallModal;
